{
  "Accessibility Menu": "പ്രവേശയോഗ്യത മെനു",
  "Reset settings": "ക്രമീകരണങ്ങൾ പുനഃസജ്ജമാക്കുക",
  "Close": "അടയ്ക്കുക",
  "Content Adjustments": "ഉള്ളടക്ക ക്രമീകരണങ്ങൾ",
  "Adjust Font Size": "അക്ഷരത്തിന്റെ വലുപ്പം ക്രമീകരിക്കുക",
  "Highlight Title": "ശീർഷകം ഹൈലൈറ്റ് ചെയ്യുക",
  "Highlight Links": "ലിങ്കുകൾ ഹൈലൈറ്റ് ചെയ്യുക",
  "Readable Font": "വായിക്കാൻ എളുപ്പമുള്ള ഫോണ്ട്",
  "Color Adjustments": "നിറ ക്രമീകരണങ്ങൾ",
  "Dark Contrast": "ഇരുണ്ട കോൺട്രാസ്റ്റ്",
  "Light Contrast": "ഇളം കോൺട്രാസ്റ്റ്",
  "High Contrast": "ഉയർന്ന കോൺട്രാസ്റ്റ്",
  "High Saturation": "ഉയർന്ന സാചുരേഷൻ",
  "Low Saturation": "കുറഞ്ഞ സാചുരേഷൻ",
  "Monochrome": "മോനോക്രോം",
  "Contrast": "കോൺട്രാസ്റ്റ്",
  "Invert Colors": "നിറങ്ങൾ മറിക്കുക",
  "Tools": "ഉപകരണങ്ങൾ",
  "Reading Guide": "വായനാ ഗൈഡ്",
  "Stop Animations": "ആനിമേഷനുകൾ നിർത്തുക",
  "Big Cursor": "വലിയ കർസർ",
  "Increase Font Size": "ഫോണ്ട് വലുപ്പം വർദ്ധിപ്പിക്കുക",
  "Decrease Font Size": "ഫോണ്ട് വലുപ്പം കുറയ്ക്കുക",
  "Letter Spacing": "അക്ഷരങ്ങൾക്കിടയിലെ ഇടവ്",
  "Line Height": "ലൈൻ ഉയരം",
  "Font Weight": "ഫോണ്ട് ഭാരം",
  "Dyslexia Font": "ഡിസ്ലെക്സിയ ഫോണ്ട്",
  "Language": "ഭാഷ",
  "Open Accessibility Menu": "പ്രവേശയോഗ്യത മെനു തുറക്കുക",
  "Widget Settings": "വിഡ്ജറ്റ് ക്രമീകരണങ്ങൾ",
  "Widget Position": "വിഡ്ജറ്റ് സ്ഥാനം",
  "Top Left": "മുകളിൽ ഇടത്",
  "Top Center": "മുകളിൽ മധ്യം",
  "Top Right": "മുകളിൽ വലം",
  "Center Left": "കേന്ദ്രം ഇടത്",
  "Center Right": "കേന്ദ്രം വലം",
  "Bottom Left": "താഴെ ഇടത്",
  "Bottom Center": "താഴെ മധ്യം",
  "Bottom Right": "താഴെ വലം",
  "Screen Reader": "സ്ക്രീൻ റീഡർ",
  "Voice Navigation": "വോയ്സ് നാവിഗേഷൻ",
  "Custom Color": "ഇഷ്ടാനുസൃത നിറം",
  "Change the site's colors": "സൈറ്റിന്റെ നിറങ്ങൾ മാറ്റുക",
  "Backgrounds": "പശ്ചാത്തലങ്ങൾ",
  "Headings": "തലക്കെട്ടുകൾ",
  "Contents": "ഉള്ളടക്കങ്ങൾ",
  "Reset colors": "നിറങ്ങൾ പുനഃസജ്ജമാക്കുക",
  "Image Desaturation": "ചിത്രത്തിലെ നിറം കുറയ്ക്കുക",
  "Search languages": "ഭാഷകൾ തിരയുക",
  "No languages found": "ഭാഷകൾ ഒന്നും കണ്ടെത്തിയില്ല",
  "Accessibility Profiles": "ആക്‌സസിബിലിറ്റി പ്രൊഫൈലുകൾ",
  "Motor Impaired": "ചലന വൈകല്യം",
  "Big cursor, voice navigation, and no animations.": "വലിയ കഴ്സർ, വോയ്സ് നാവിഗേഷൻ, അനിമേഷൻ ഒന്നുമില്ല.",
  "Blind": "കാണാനാവാത്തവർ",
  "Screen reader helpers with higher contrast.": "കൂടുതൽ കോൺട്രാസ്റ്റുള്ള സ്ക്രീൻ റീഡർ സഹായങ്ങൾ.",
  "Color Blind": "വർണ്ണാന്ധ്യം",
  "High contrast palette with desaturated media.": "ഉയർന്ന കോൺട്രാസ്റ്റ് പ്യാലറ്റ്, കുറഞ്ഞ നിറമുള്ള മീഡിയ.",
  "Dyslexia": "ഡിസ്ലെക്സിയ",
  "Friendly font, extra spacing, stronger weight.": "വായിക്കാൻ എളുപ്പമുള്ള ഫോണ്ട്, കൂടുതൽ സ്പേസിംഗ്, കട്ടിയുള്ള എഴുത്ത്.",
  "Low vision": "കുറഞ്ഞ കാഴ്ച",
  "Dark contrast and 130% magnification.": "ഇരുണ്ട കോൺട്രാസ്റ്റും 130% സൂം.",
  "Cognitive & Learning": "ബൗദ്ധികവും പഠനസഹായവും",
  "Highlights key sections and enables voice help.": "പ്രധാന ഭാഗങ്ങളെ ഹൈലൈറ്റ് ചെയ്യുകയും വോയ്സ് സഹായം സജീവമാക്കുകയും ചെയ്യുന്നു.",
  "Seizure & Epileptic": "ഫിറ്റ്സ് & എപ്പിലപ്സി",
  "Stops animations and desaturates imagery.": "അനിമേഷൻ നിര്‍ത്തുകയും ചിത്രങ്ങളുടെ നിറം കുറയ്ക്കുകയും ചെയ്യുന്നു.",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "വായനാ ഗൈഡ്, ഹൈലൈറ്റ് ചെയ്‌ത ലിങ്കുകൾ, ശാന്തമായ നിറങ്ങൾ.",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
